/* Brand bullets on product pages: paragraphs written as "- Text" lose the typed dash and get the class
   .brand-bullet, which component-brand-list.css styles with the slanted navy marker.
   Without JS the typed dash simply stays. */
(function () {
  var DASH = /^\s*[-–—•]\s+/;

  function firstTextNode(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim() !== '') return node;
    }
    return null;
  }

  function apply(root) {
    var paragraphs = root.querySelectorAll('.product__details p:not(.brand-bullet)');
    Array.prototype.forEach.call(paragraphs, function (p) {
      if (!DASH.test(p.textContent)) return;
      var node = firstTextNode(p);
      if (!node || !DASH.test(node.textContent)) return;
      node.textContent = node.textContent.replace(DASH, '');
      p.classList.add('brand-bullet');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(document); });
  } else {
    apply(document);
  }
  document.addEventListener('shopify:section:load', function (event) { apply(event.target); });
})();
